




























import Vue from 'vue'
export default Vue.extend({
  props: {
    price: [String, Number],
    quoteChange: [String],
    marketValue: Number,
  },
})
